var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};

// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSThemeConfig.custom.products_per_page,	
		/* Optional */	
		loadProductFirst: false,
      	filterTreeMobileStyle: 'style1', 
	},
};

// Declare Templates
var boostPFSTemplate = {
    // Grid Template
    'productGridItemHtml': 	'<div>' +
  								'<div class="{{itemSaleClass}} {{itemTaggedClass}} product-grid-item" data-grid-item>' +
                                    '<div {{autoHeight}}>' +
                                        '<a href="{{itemUrl}}" data-grid-link class="lazy-image {{doubleImageClass}}" style="{{imageStyle}}">' +
                                            '{{itemImages}}' +
                                            '{{itemLabels}}' +
                                        '</a>' +
                                    '</div>' +
                                    '{{imageScript}}' +
                                    '<div class="figcaption product__grid__info product__grid__info--' + boostPFSThemeConfig.custom.product_grid_style + ' ' + boostPFSThemeConfig.custom.collection_text_alignment + '">' +
                                        '<a href="{{itemUrl}}">' +
                                            '<p class="product__grid__title">{{itemTitle}}</p>' +
  											'{{itemReviews}}' +
                                            '<p class="product__grid__price">{{itemPrice}}</p>' +
                                        '</a>' +
                                    '</div>' +
  								'</div>' +
                            '</div>',

    // Pagination Template
    'previousActiveHtml': '<li class="pagination-custom__arr">' +
                            '<a href="{{itemUrl}}" title="Previous">' +
                              '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-small-left" viewBox="0 0 17 30"><path fill-rule="evenodd" d="M13.765 30L0 15.002 13.765 0 17 3.527 6.491 15.002 17 26.475z"/></svg>' +
                            '</a>' +
                          '</li>',
    'previousDisabledHtml': '<li class="disabled pagination-custom__arr">' +
                              '<span>' +
                                '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-small-left" viewBox="0 0 17 30"><path fill-rule="evenodd" d="M13.765 30L0 15.002 13.765 0 17 3.527 6.491 15.002 17 26.475z"/></svg>' +
                              '</span>' +
                            '</li>',
    'nextActiveHtml': '<li class="pagination-custom__arr">' +
                        '<a href="{{itemUrl}}" title="Previous">' +
                          '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-small-right" viewBox="0 0 17 30"><path fill-rule="evenodd" d="M3.235 30L0 26.475l10.509-11.473L0 3.527 3.235 0 17 15.002z"/></svg>' +
                        '</a>' +
                      '</li>',
    'nextDisabledHtml': '<li class="disabled pagination-custom__arr">' +
                          '<span>' +
                            '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-small-right" viewBox="0 0 17 30"><path fill-rule="evenodd" d="M3.235 30L0 26.475l10.509-11.473L0 3.527 3.235 0 17 15.002z"/></svg>' +
                          '</span>' +
                        '</li>',
    'pageItemHtml': '<li class="pagination-custom__num"><a href="{{itemUrl}}" title="{{itemTitle}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li class="pagination-custom__num active"><span><span>{{itemTitle}}</span></span></li>',
    'pageItemRemainHtml': '<li class="pagination-custom__num pagination-custom__num--dots"><span>{{itemTitle}}</span></li>',
    'paginateHtml': '<ul class="pagination-custom">' +
                      '{{previous}}' +
                      '<li class="pagination-custom__spacer"><span>&#8203;</span></li>' +
                      '{{pageItems}}' +
                      '<li class="pagination-custom__spacer"><span>&#8203;</span></li>' +
                      '{{next}}' +
                    '</ul>',
  
    // Sorting Template
    'sortingHtml': '{{sortingItems}}'
};

(function() {
	BoostPFS.inject(this);
	
	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
		// Displaying price base on the policy of Shopify, have to multiple by 100
		soldOut = !data.available; // Check a product is out of stock
		onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Convert images to array
		images = data.images_info;
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		return data;
	}
	/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);
		
      	var new_product = false;
        var published_date = new Date(data.published_at).getTime() / 1000;
        var now_date = new Date().getTime() / 1000;
        var age_in_days = (now_date - published_date) / 3600 / 12;
        if (age_in_days < boostPFSThemeConfig.custom.tag_new_limit) {
            new_product = true;
        }

        var sellout_tag = false;
        if (soldOut && boostPFSThemeConfig.custom.tag_sale) {
            sellout_tag = true;
        }

        var new_tag = false;
        if (new_product && boostPFSThemeConfig.custom.tag_new) {
            new_tag = true;
        }

        var sale_tag = false;
        if (onSale && boostPFSThemeConfig.custom.tag_sale) {
            sale_tag = true;
        }

        var custom_badge = false
        // console.log(data.tags.forEach(e) => )
      var custom_badge_result = data.tags.filter(e => e.indexOf("_badge_") > -1)
      var custom_badge_content = "";
      if(custom_badge_result[0]){var custom_badge_content = custom_badge_result[0].replace("_badge_", "")}
      if(custom_badge_content){
        custom_badge = true
      }

        var tagged = false;
        if (sellout_tag || new_tag || sale_tag || custom_badge) {
            tagged = true;
        }

        var itemHtml = boostPFSTemplate.productGridItemHtml;

        // Add onSale class
        var onSaleClass = onSale ? 'on-sale' : '';
        itemHtml = itemHtml.replace(/{{itemSaleClass}}/g, onSaleClass);

        // Add Tagged class
        var taggedClass = tagged ? 'tagged' : '';
        itemHtml = itemHtml.replace(/{{itemTaggedClass}}/g, taggedClass);

        // Add Image Class
        var double_img = (images.length > 1 && boostPFSThemeConfig.custom.image_hover_enable) ? 'double__image' : '';
        itemHtml = itemHtml.replace(/{{doubleImageClass}}/g, double_img);

        // Add autoHeight
        var autoHeightHtml = '',
            aspect_ratio = 1,
            top_offset = '';
        if (boostPFSThemeConfig.custom.image_autoheight_enable) {
          if (images.length > 0) {
            aspect_ratio = images[0]['width'] / images[0]['height'];
            top_offset = 1 / aspect_ratio * 100 / 2;

            if (aspect_ratio < 1) {
              autoHeightHtml = 'style="width:' + (aspect_ratio * 100) + '%; margin: 0 auto;"';
            } else {
              autoHeightHtml = 'style="padding:' + (50 - top_offset) + '% 0;"';
            }
          }
        }
        itemHtml = itemHtml.replace(/{{autoHeight}}/g, autoHeightHtml);

        // Add Image style
        var imageStyleHtml = '';
        aspect_ratio = images.length > 0 ? images[0]['width'] / images[0]['height'] : aspect_ratio;
        imageStyleHtml += 'padding-top: ' + (1 / aspect_ratio * 100) + '%;';
        if (images.length > 0) {
            imageStyleHtml += 'background-image:  url(' + Utils.optimizeImage(images[0]['src'], '1x1') + ');';
        } else {
            imageStyleHtml += 'background-image:  none;';
        }
        itemHtml = itemHtml.replace(/{{imageStyle}}/g, imageStyleHtml);

        // Add Image
        var itemImagesHtml = '<img class="lazyload fade-in" ' +
                                'src="' + Utils.getFeaturedImage(images, '300x300') + '" ' +
                                'data-src="' + Utils.getFeaturedImage(images, '{width}x') + '" ' +
                                'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048, 2450, 2700, 3000, 3350, 3750, 4100, 4480]" ' +
                                'data-aspectratio="' + aspect_ratio + '" ' +
                                'data-sizes="auto" ' +
                                'alt="{{itemTitle}}">';
        if (double_img) {
            itemImagesHtml += '<div class="collection__image__bottom lazyload" data-bgset="' + bgset(images[1]) + '"></div>';
        }
        itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

        // Add Image Script
        var imageScriptHtml = '';
        imageScriptHtml += '<noscript>';
        imageScriptHtml += '<a href="{{itemUrl}}"';
        imageScriptHtml += '<img class="rimage__image " src="' + Utils.getFeaturedImage(images, '360x') + '" alt="{{itemTitle}}">'; 
        imageScriptHtml += '</a>';
        imageScriptHtml += '</noscript>';  
        itemHtml = itemHtml.replace(/{{imageScript}}/g, imageScriptHtml);

        // Add Thumbnail
        var itemThumbUrl = images.length > 0 ? Utils.optimizeImage(images[0]['src']) : boostPFSAppConfig.general.no_image_url;
        itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

        // Add Labels
        var itemLabelsHtml = '';
        if (tagged) {
            if (sellout_tag) {
                itemLabelsHtml += '<div class="product__badge product__badge--sold">' + boostPFSThemeConfig.label.sold_out + '</div>';
            } else if (sale_tag) {
                itemLabelsHtml += '<div class="product__badge product__badge--sale">' + boostPFSThemeConfig.label.sale + ' ' + data.percent_sale_min + '%</div>';
            } else if (new_tag) {
                itemLabelsHtml += '<div class="product__badge product__badge--new">' + boostPFSThemeConfig.label.new + '</div>';
            } else if (custom_badge){
              itemLabelsHtml += '<div class="product__badge product__badge--sale">' + custom_badge_content + '</div>';
            }
        }
        itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);

        // Add Price

        var itemPriceHtml = '<span class="price">';
        if (priceVaries) {
            itemPriceHtml += boostPFSThemeConfig.label.from_price + ' ';
        }
      	var classOnSale = onSale ? "on-sale" : ""
        // itemPriceHtml += '<span class="money ' + classOnSale + ' factcheck">' + Utils.formatMoney(data.price_min) + '</span>';
        itemPriceHtml += '<span class="moneys ' + classOnSale + ' factcheck">' + Utils.formatMoney(data.price_min) + '</span>';
        if (soldOut) {
            itemPriceHtml += '<br /><em>' + boostPFSThemeConfig.label.sold_out + '</em>';
        }
        if (onSale) {
            itemPriceHtml += '<span class="compare-at">' +
                                '<span class="moneys">' + Utils.formatMoney(data.compare_at_price_min) + '</span>' +
                            '</span>';
        }
        itemPriceHtml += '</span>';
        itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

        // Add Review
       itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReviews(data));

        // Add main attribute
        itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
        itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
        itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
      
		return itemHtml;
	};
	/************************** END BUILD PRODUCT LIST **************************/
	/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
  	function bgset(image){
        var bgset = '';
        if(image){
            var aspect_ratio = image.width / image.height;

            if ( image.width > 180 ) bgset += ' ' + Utils.optimizeImage(image.src, '180x') + ' 180w ' + Math.round(180/aspect_ratio) + 'h,';
            if ( image.width > 360 ) bgset += ' ' + Utils.optimizeImage(image.src, '360x') + ' 360w ' + Math.round(360/aspect_ratio) + 'h,';
            if ( image.width > 540 ) bgset += ' ' + Utils.optimizeImage(image.src, '540x') + ' 540w ' + Math.round(540/aspect_ratio) + 'h,';
            if ( image.width > 720 ) bgset += ' ' + Utils.optimizeImage(image.src, '720x') + ' 720w ' + Math.round(720/aspect_ratio) + 'h,';
            if ( image.width > 900 ) bgset += ' ' + Utils.optimizeImage(image.src, '900x') + ' 900w ' + Math.round(900/aspect_ratio) + 'h,';
            if ( image.width > 1080 ) bgset += ' ' + Utils.optimizeImage(image.src, '1080x') + ' 1080w ' + Math.round(1080/aspect_ratio) + 'h,';
            if ( image.width > 1296 ) bgset += ' ' + Utils.optimizeImage(image.src, '1296x') + ' 1296w ' + Math.round(1296/aspect_ratio) + 'h,';
            if ( image.width > 1512 ) bgset += ' ' + Utils.optimizeImage(image.src, '1512x') + ' 1512w ' + Math.round(1512/aspect_ratio) + 'h,';
            if ( image.width > 1728 ) bgset += ' ' + Utils.optimizeImage(image.src, '1728x') + ' 1728w ' + Math.round(1728/aspect_ratio) + 'h,';
            if ( image.width > 1950 ) bgset += ' ' + Utils.optimizeImage(image.src, '1950x') + ' 1950w ' + Math.round(1950/aspect_ratio) + 'h,';
            if ( image.width > 2100 ) bgset += ' ' + Utils.optimizeImage(image.src, '2100x') + ' 2100w ' + Math.round(2100/aspect_ratio) + 'h,';
            if ( image.width > 2260 ) bgset += ' ' + Utils.optimizeImage(image.src, '2260x') + ' 2260w ' + Math.round(2260/aspect_ratio) + 'h,';
            if ( image.width > 2450 ) bgset += ' ' + Utils.optimizeImage(image.src, '2450x') + ' 2450w ' + Math.round(2450/aspect_ratio) + 'h,';
            if ( image.width > 2700 ) bgset += ' ' + Utils.optimizeImage(image.src, '2700x') + ' 2700w ' + Math.round(2700/aspect_ratio) + 'h,';
            if ( image.width > 3000 ) bgset += ' ' + Utils.optimizeImage(image.src, '3000x') + ' 3000w ' + Math.round(3000/aspect_ratio) + 'h,';
            if ( image.width > 3350 ) bgset += ' ' + Utils.optimizeImage(image.src, '3350x') + ' 3350w ' + Math.round(3350/aspect_ratio) + 'h,';
            if ( image.width > 3750 ) bgset += ' ' + Utils.optimizeImage(image.src, '3750x') + ' 3750w ' + Math.round(3750/aspect_ratio) + 'h,';
            if ( image.width > 4100 ) bgset += ' ' + Utils.optimizeImage(image.src, '4100x') + ' 180w ' + Math.round(4100/aspect_ratio) + 'h,';
            bgset += ' ' + image.src + ' ' + image.width + 'w ' + image.height + 'h,';
        }
        return bgset;
    }
	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}
		if (totalPage > 1) {
			var paginationHtml = boostPFSTemplate.paginateHtml;
			// Build Previous
			var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
			// Build Next
			var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...');
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);
			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...');
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}
			// Build page items
			var pageItemsHtml = '';
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == '...') {
					pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
					pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
			return paginationHtml;
		}
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (!Utils.isSearchPage() && boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				var paramSort = Globals.queryParams.sort || '';
				// Build content
				var sortingItemsHtml = '';
              	var sortOptions = boostPFSThemeConfig.label.sort_options;
              	var flag = false;
				for (var k in sortingArr) {
					if(paramSort == k) {
						flag = true;
					}
                    var sortOptionsName = sortOptions.filter(function(e) {
						return e[0] == k;
                    });
                  	var sortName = typeof sortOptionsName[0] !== 'undefined' ? sortOptionsName[0][1] : sortingArr[k];
                  	sortingItemsHtml += '<li class="popout-list__item ' + (flag ? 'popout-list__item--current' : '') + '">';
                  	sortingItemsHtml += '<a class="popout-list__option" data-value="' + k + '" href="#" ' + (flag ? 'aria-current="true"' : '') + ' data-sort-link>';
            		sortingItemsHtml += '<span>' +  sortName + '</span>';
          			sortingItemsHtml += '</a>';
                    sortingItemsHtml += '</li>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};
  
  	ProductSorting.prototype.bindEvents = function () {
		var _this = this;
		jQ(Selector.topSorting + ' li').click(function (e) {
			e.preventDefault();
			FilterApi.setParam('sort', jQ(this).find('a').data('value'));
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
		});
	};
	/************************** END BUILD TOOLBAR **************************/
	
	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function (data) {
      	if (!data) data = this.data;
        if(typeof(conversionBearAutoCurrencyConverter) !== 'undefined'){
          // conversionBearAutoCurrencyConverter.convertPricesOnPage();
        }
       
	};

	// Build additional elements
	Filter.prototype.afterRender = function(data) {
		if (!data) data = this.data;
	};

	/* Prevent conflict with theme vendor js 
	Array.prototype.insert = function(a, b) {}
    
    function buildReviews(data) {
	// Build Labels
      var  html = '';
      if (Utils.getProductMetafield(data, 'judgeme', 'badge') !== null) {
        html = "<div data-auto-install='false' data-template='collection' id='judgeme_product_reviews' class='jdgm-widget jdgm-preview-badge jdgm-review-widget' data-id='" + data.id + "'>" + Utils.getProductMetafield(data, 'judgeme', 'badge').replace(/\|/g, '"') + "</div>";
      }
      return html;
    }
*/ 
    function buildReviews(data) {
	// Build Labels
      var  html = '';
      if (Utils.getProductMetafield(data, 'judgeme', 'badge') !== null) {
        html = "<div data-auto-install='false' data-template='collection' id='judgeme_product_reviews' class='jdgm-widget jdgm-preview-badge jdgm-review-widget' data-id='" + data.id + "'>" + Utils.getProductMetafield(data, 'judgeme', 'badge').replace(/\|/g, '"') + "</div>";
      }
      return html;
    }
})();
